import React, { FunctionComponent } from "react";
import {
    Modal,
    PrimaryButton,
    IconButton
} from "@fluentui/react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
    contentStyles as content,
    iconButtonStyles,
    cancelIcon,
} from "constants/styles";
import { CustomFontText } from "components/customFontText/CustomFontText";
import { Col, Row } from "react-grid-system";

const contentStyles = content(600, "auto");

interface IProps {
    onDismiss: () => void;
    isOpen: boolean;
    handleTryAgain: () => void;
    handleEnterManually: () => void;
}

export const ImportLeadCustomerNotFoundDialog: FunctionComponent<IProps> = ({
    onDismiss,
    isOpen,
    handleTryAgain,
    handleEnterManually,
}) => {

    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container + " custom-modal"}
            className="vehicleFoundDialog"
        >
            <div className={contentStyles.header + " inventory-popup"}>
                {/*<GoBackToMainDialogBtn label="" onClick={onDismiss} />*/}
                <CustomFontText className="formTitle">Customer Last Name Not Found</CustomFontText>

                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            <div className="dealRecFound body-auto-hight body-min-height-50">
                <div style={{ marginLeft: "25px",textAlign:"left"}}>
                    <div>
                        <label className="lbl-text"> No lead matching Customer’s Last Name can be found.</label>
                    </div>
                </div>
            </div>
            <div className={contentStyles.footer + " inventory-popup-footer"} style={{ padding: "18px 55px " }}>
                 <Row className="inventoryRowSection footerBtn cusNoNotFoundFoot">
                      <Col>
                          <PrimaryButton
                              style={{ float: "left",width:'75%'}}
                              onClick={handleTryAgain}
                              text="Try Again"
                              className="cusNoNotFoundDiaBtnHeight"
                          />
                      </Col>
                      <Col>
                          <PrimaryButton
                              text="Enter Manually"
                              style={{ float: "right" }}
                              onClick={handleEnterManually}
                              className=" cusNoNotFoundDiaBtnHeight"
                          />

                      </Col>
                    </Row>
            </div>
        </Modal>
    );
};



